import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function submitLead(payload) {
  const { data } = await axios.post(`${API}/leads`, payload);
  return data;
}

export { API };
